import { Button as _Button } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const Button = styled(_Button)`
  width: 100%;
  height: 40px;
  white-space: nowrap;
`;
